import React from 'react';
import { Countdown } from './Countdown';
import { ANCHOR_PRICE } from '../lib/config';
export function Urgency() {
  return <section className="w-full bg-ink py-16 sm:py-20" data-id="element-274" data-mp="2bvcwml61ownb">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-275" data-mp="1wzng32jmpbpz">
        <p className="text-[11px] uppercase tracking-[0.3em] text-gold" data-id="element-276" data-mp="1wz5c1jqq5t7i">
          Precio de lanzamiento — termina en
        </p>

        <div className="mt-8" data-id="element-277" data-mp="1o73fvxnouz31">
          <Countdown tone="dark" data-id="element-278" data-mp="1o6tpi8yqepwt" />
        </div>

        <p className="mt-8 text-base text-ivory/80" data-id="element-279" data-mp="1o50gwo4k5vm6">
          Después vuelve a su precio regular de{' '}
          <span className="font-serif text-xl text-gold" data-id="element-280" data-mp="1szmtgumdlu7u">{ANCHOR_PRICE} USD</span>. Para
          siempre.
        </p>

        <div className="mx-auto mt-10 max-w-md" data-id="element-281" data-mp="1j7qpx41itbw8">
          <div className="h-1.5 w-full overflow-hidden bg-white/10" role="progressbar" aria-valuenow={88} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos a precio de lanzamiento ya tomados" data-id="element-282" data-mp="1j8i9thlr9l6o">
            <div className="h-full bg-gold" style={{
            width: '88%'
          }} data-id="element-283" data-mp="25xz7clzkv51h" />
          </div>
          <p className="mt-3 text-[11px] uppercase tracking-[0.16em] text-ivory/50" data-id="element-284" data-mp="210z3mhq7aedj">
            88% de los cupos a precio de lanzamiento ya fueron tomados
          </p>
        </div>
      </div>
    </section>;
}